<template>
  <FlexContainer
    class="modalContainer"
    justifyContent="center"
    alignItems="center"
    @click="$emit('toggleModal')"
  >
    <div class="modalContent" @click.stop="">
      <FlexContainer class="modalHeader">
        <slot name="header">
          <h1 v-if="title">{{ title }}</h1>
          <span @click="$emit('toggleModal')">X</span>
        </slot>
      </FlexContainer>
      <div class="modalBody">
        <slot name="body"></slot>
      </div>
      <FlexContainer class="modalFooter" justifyContent="flex-end">
        <slot name="footer"></slot>
      </FlexContainer>
    </div>
  </FlexContainer>
</template>

<script>
import FlexContainer from "../FlexContainer.vue";

export default {
  components: { FlexContainer },
  data() {},
  props: {
    title: String,
  },
  methods: {},
};
</script>

<style scoped>
.modalContainer {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: var(--vt-c-black-overlay);

  .modalContent {
    min-width: 30%;
    padding: 2rem;
    background-color: var(--vt-c-black-mute);
    border-radius: 1rem;

    .modalHeader {
      border-bottom: 1px solid var(--vt-c-divider-dark-1);
      margin-bottom: 1rem;
      padding-bottom: 1rem;

      & h1 {
        flex: 1;
      }

      & span {
        cursor: pointer;
      }
    }

    .modalFooter {
      border-top: 1px solid var(--vt-c-divider-dark-1);
      margin-top: 1rem;
      padding-top: 1rem;
    }
  }
}
</style>
